<template>
    <div class="login">
        <div class="headerTitle">河北省雷达联网在线分析平台</div>
        <div class="loginForm">
            <van-cell-group>
                <van-field
                        v-model="loginForm.username"
                        clearable
                        left-icon="contact"
                        placeholder="请输入用户名"
                        :error-message="userNameMsg"
                />

                <van-field
                        v-model="loginForm.password"
                        type="password"
                        left-icon="eye-o"
                        placeholder="请输入密码"
                        :error-message="pwdMsg"
                />
                <div class="loginBtn">
                    <van-button type="info" size="small" :disabled="loginBtnShow" @click="login">登录</van-button>
                </div>
            </van-cell-group>
        </div>
        <div class="copyRight">© 北京环拓科技有限公司</div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import axios from 'axios';
    export default {
        name: '',
        data () {
            return {
                loginForm:{
                    username:'',
                    password:'',
                },
                userNameMsg:'',
                pwdMsg:'',
                loginBtnShow:true,
            }
        },
        //监控
        watch: {
            loginForm: {
                handler(val) {
                    if(val.username === '' || val.password === ''){
                        this.loginBtnShow=true;
                    }else if(val.username !== '' && val.password !== ''){
                        this.loginBtnShow=false;
                    }
                },
                deep: true,
                immediate: true
            }
        },
        methods: {
            login(){
                let _this=this;
                let url=_this.apiIp.getLogin+'?account='+_this.loginForm.username+'&password='+_this.loginForm.password;
                let loading=_this.$toast.loading({
                    duration:0,
                    message: '登录中...'
                });
                $.ajax({
                    url:url,
                    type:'GET',
                    //contentType: "application/json; charset=utf-8",
                    //data: {'jData':formData,'operatorType':_this.operatorType},
                    //dataType: "json",
                    success:function(result){
                        if(result.IsSuccess){
                            loading.clear();
                            let userData=result.Data;
                            console.log(userData);
                            //存储localStorage
                            _this.loginForm.userData=userData;
                            console.log(_this.loginForm);
                            let LoginStr=JSON.stringify(_this.loginForm);
                            localStorage.setItem('user',LoginStr);
                            //跳转首页
                            //_this.$router.push('/RealTime')
                            _this.myData(_this.loginForm.username);
                        }else{
                            loading.clear();
                            _this.$toast.fail({
                                duration:800,
                                message:result.ErrorMessage
                            });
                            _this.loginForm.password='';
                        }
                    },
                    error:function (result) {
                        loading.clear();
                        _this.$toast.fail({
                            duration:800,
                            message:'登录失败'
                        });
                        _this.loginForm.password='';
                    }
                });
            },
            // 接收数据
            myData(userName) {
                let me = this;
                let url = me.apiIp.getInfromEnter;
                //localStorage.removeItem('inform');

                var username = userName
                axios.get(url, {
                        headers: {
                            account: username,
                            'Cache-Control': 'no-cache'
                        }
                    }).then(res => {
                        var arr = JSON.parse(res.data.Data);
                        console.log(arr);
                        // 将所有子站点的名字和坐标添加至数据库
                        arr=arr[0];
                        sessionStorage.setItem('powerData', JSON.stringify(arr));
                        //console.log(arr);
                        me.$router.push('/RealTime');
                    }).catch(err => {
					console.log(err);
				});   
            },
            //初始化用户名密码
            initUserPwd(){
                let _this=this;
                let local=localStorage.getItem('user');
                if(local){
                    let localObj=eval('('+local+')');
                    if(typeof localObj === "object"){
                        _this.loginForm=localObj;
                    }else{
                        localStorage.removeItem('user');
                        _this.loginForm={
                            username:'',
                            password:'',
                        };
                    }
                }
            },
            //初始化页面高度
            initPageHeight(){
                let _this=this;
                let bodyHeight=$("body").height();
                $(".login").css("height",bodyHeight);
            },
            //删除缓存site
            removeSiteData(){
                localStorage.removeItem('site')
            },
        },
        mounted() {
            this.initPageHeight();
            this.initUserPwd();
            this.removeSiteData();
            $(".van-field__control").css("color","#FFFFFF");
            $(".van-field__body").css("border","none");
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import "../style/login.css";
    .login{
        width: 100%;
        height: 100%;
        position: relative;
        background: url("../assets/img/bg_1.jpg");
        background-size: 100% 100%;
        .van-cell-group{
            background: transparent;
        }
        .van-cell{
            margin-top: 20px;
            background: transparent;
            color: #FFFFFF;
            border: none;
        }
        .van-field__control{
            color: #FFFFFF !important;
        }
        .van-cell__value--alone{
            color: #FFFFFF !important;
        }
        .van-hairline--top-bottom:after{
            border: none;
        }
        .van-cell:not(:last-child):after{

        }
        input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
            color: #FFFFFF;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue